APPS.franchises.custom_curate = (function(){
    var show = function(id){
	    //loading animation
        APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))

		window.document.title = "Curate Franchise";
		
    	APP.getView().showChildView('mainRegion', new pageView() )
    	
		if(typeof ga != "undefined"){ 
			ga('set','title',"Curate Franchise");
			ga('send','pageview');
		}
		if(typeof gtag != "undefined"){
			gtag('set', { 'page_title': 'Curate Franchise' });
			gtag('event', 'page_view');
		}
		if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "Curate Franchise", '0', false, true); }
	
	}
	
	
	/****************************************************
		VIEWS
	 ****************************************************/
	 	
	 	//list the programs
		var programView = Marionette.View.extend({
			 tagName:"div"
            ,className:"col-6 col-sm-4"
            ,template:_.template('<div class="row program p0"><div class="col-12"><a href="/program/<%-slug%>"><img style="max-width:100%" src="<%=images%>.crop.240x360.jpg"/><h1 class="h2 m0 mt1 font-normal"><%-title%></h1></a><p class="font-light"><%-desc_short%></p></div></div>')
            ,templateContext:function(){
	            var img = Backbone.Radio.channel('utilities').request('image-parse',{
		             json:this.model.attributes.images
		            ,desiredProfile:"show-poster2x3"
		        });
                
                return {
                    images: img
                }
            }
		})
		 var collectionProgramView = Mn.CollectionView.extend({
	         tagName: 'div'
	        ,className:"row"
	        ,childView: programView
	    });
	    
	    
	    //show the most recent episode
	    var epiosdeView = Marionette.View.extend({
			 tagName:"div"
            ,className:"col-12"
            ,template:"#tmpl-franchise-curate-mostRecent"
            ,templateContext:function(){
	            var preferredAsset;
	            preferredAsset = _.findWhere(this.model.attributes.assets, {type:'full_length'});
	            if(!preferredAsset){ preferredAsset = _.findWhere(this.model.attributes.assets, {type:'preview'}) }
	            if(!preferredAsset){ preferredAsset = assets[0]; }

	            var duration = Backbone.Radio.channel('time').request('formatDuration',preferredAsset.duration*1000)
	            
                return {
			         preferredAsset:preferredAsset
			        ,duration:duration
			        ,poster:Backbone.Radio.channel('utilities').request('image-parse',{json:preferredAsset.images,desiredProfile:"asset-mezzanine-16x9"})
			        ,showTitle:this.model.collection.state.showDetails.title
			        ,showSlug:this.model.collection.state.showDetails.slug
		        }
            }
            ,onAttach:function(){
	            var that = this;
	        
	            var assets = this.model.attributes.assets;
	            /* If there is only one result, it's an object, so make it an array */
	            if(!Array.isArray(assets)){ assets[0] = assets; }
	            
	            var preferredAsset;
	            preferredAsset = _.findWhere(assets, {type:'full_length'});
	            if(!preferredAsset){ preferredAsset = _.findWhere(assets, {type:'preview'}) }
	            if(!preferredAsset){ preferredAsset = assets[0]; }
	            
	            //is Public, or is Passport and you're logged in
	            if(+preferredAsset.is_public || (Backbone.Radio.channel('account').request('isSignedIn') && +preferredAsset.is_passport) ){
	                Backbone.Radio.channel('media').request('setupMedia',{asset:preferredAsset,target:"player",program:this.model.collection.state.showDetails})
		        }
            }
		})
	    
	    
	    // THE PAGE
        var pageView = Marionette.View.extend({
             template:"#tmpl-franchise-curate"
            ,className:"mt8 franchise_curate"
            ,regions:{
                 mostRecent:{
                    el: '#curate_mostRecentContainer'
                }
                ,programs:{
                    el: '#curate_programsContainer'
                }
            }
            ,onRender: function() {
	            var that = this;
			    
			    
			    //$.when(  Backbone.Radio.channel('entities').request('show','curate') )
			    $.when(  Backbone.Radio.channel('entities').request('episodes',{showId:'curate'})
			    	,Backbone.Radio.channel('entities').request('episodes',{showId:'curate-757'})
			    	,Backbone.Radio.channel('entities').request('episodes',{showId:'curate-u'}) )
			    .done(function(show1, show2, show3){
				    //list the programs
				    that.showChildView('programs', new collectionProgramView({
	                    collection: new Backbone.Collection([show1.state.showDetails,show2.state.showDetails,show3.state.showDetails])
	                }));
	                
	            	//find the most recent
					// #183724913 - At one point, it was decided that the Most Recent section should not have Curate in it.
					// It was also decided that multiple things would be updated in a single day, and that the most recently aired
					//	should be the one that is shown. But the airdate only has the date, not the time, so we reverse the episode list
					//	and hope that the episodes were added to the db in order, which should always be the case for episodes that were 
					//	uploaded in the order of their airdate.  
					//let curateepisodes = show1.models.reverse();
					let curate757episodes = show2.models.reverse();
					let curateUepisodes = show3.models.reverse();
					
	            	//var newestShow1 = _.max(curateepisodes,function(m){ return m.attributes.airdate.replace(/[^0-9]/g,''); })
	            	var newestShow2 = _.max(curate757episodes,function(m){ return m.attributes.airdate.replace(/[^0-9]/g,''); })
	            	var newestShow3 = _.max(curateUepisodes,function(m){ return m.attributes.airdate.replace(/[^0-9]/g,''); })
					var newest = _.max([newestShow2,newestShow3],function(m){ 
						return m.attributes.airdate.replace(/[^0-9]/g,''); 
					})
					
	            	that.showChildView('mostRecent', new epiosdeView({ model: newest }));
				});
            }
        })
	    
	return {
		show:show
	}
})();